enum ResizeType {
  FIT = 'fit',
  FILL = 'fill',
  FILL_DOWN = 'fill-down',
  FORCE = 'force',
  AUTO = 'auto',
}

export default ResizeType;
